import { useState } from 'react'
import Countdown, { zeroPad } from 'react-countdown'

import Button from './Button'
import Logo from './Logo'
import Body from './typography/Body'
import Bravo from './typography/Bravo'

export default function CountdownToStart({
  date,
  returnCompleted,
  fromPlay,
  dark
}) {
  function split(num) {
    const digits = zeroPad(num).toString().split('')
    return digits
  }

  const renderer = ({ days, hours, minutes, seconds, completed }) => {
    // Render a countdown
    if (completed) returnCompleted()

    return (
      <div
        className={`${dark ? 'text-black' : 'text-white'} flex justify-center`}
      >
        {days > 0 && (
          <div>
            <div className="flex mr-5">
              <div className="bg-blue-800 text-countdown-fluid text-white rounded-md font-bold mr-4 p-5 w-50">
                {days > 100 ? 9 : split(days)[0] ?? 0}
              </div>
              <div className="bg-blue-800 text-countdown-fluid text-white rounded-md font-bold p-5 w-50">
                {days > 100 ? 9 : split(days)[1] ?? 0}
              </div>
            </div>
            <div className={`w-full mt-5 ${fromPlay ? 'text-black' : ''}`}>
              Days
            </div>
          </div>
        )}
        <div>
          <div className="flex mx-5">
            <div className="bg-blue-800 text-countdown-fluid text-white rounded-md font-bold mx-4 p-5 w-50">
              {split(hours)[0] ?? 0}
            </div>
            <div className="bg-blue-800 text-countdown-fluid text-white rounded-md font-bold p-5 w-50">
              {split(hours)[1] ?? 0}
            </div>
          </div>
          <div className={`w-full mt-5 ${fromPlay ? 'text-black' : ''}`}>
            Hours
          </div>
        </div>
        <div>
          <div className="flex mx-5">
            <div className="bg-blue-800 text-countdown-fluid text-white rounded-md font-bold p-5 w-50">
              {split(minutes)[0] ?? 0}
            </div>
            <div className="bg-blue-800 text-countdown-fluid text-white rounded-md font-bold ml-4 p-5 w-50">
              {split(minutes)[1] ?? 0}
            </div>
          </div>
          <div className={`w-full mt-5 ${fromPlay ? 'text-black' : ''}`}>
            Minutes
          </div>
        </div>
        {days === 0 && (
          <div>
            <div className="flex ml-5">
              <div className="bg-blue-800 text-countdown-fluid text-white rounded-md font-bold p-5 w-50">
                {split(seconds)[0] ?? 0}
              </div>
              <div className="bg-blue-800 text-countdown-fluid text-white rounded-md font-bold ml-4 p-5 w-50">
                {split(seconds)[1] ?? 0}
              </div>
            </div>
            <div className={`w-full mt-5 ${fromPlay ? 'text-black' : ''}`}>
              Seconds
            </div>
          </div>
        )}
      </div>
    )
  }

  return (
    <>
      {fromPlay ? (
        <div className="mt-20">
          <Body className="text-black mb-20 font-bold">
            Quiz Starting in...
          </Body>
          <div className="text-center">
            {date && <Countdown date={date} renderer={renderer} />}
          </div>
        </div>
      ) : (
        <div className="text-center mt-50">
          <Bravo
            className={`${dark ? 'text-black' : 'text-white'} mb-20 font-bold`}
          >
            Quiz Starting in...
          </Bravo>
          {date && <Countdown date={date} renderer={renderer} />}
        </div>
      )}
    </>
  )
}
